import React from "react";
import PropTypes from "prop-types";
import BookingEventCardAdmin from "./BookingEventCardAdmin";
import TestingEventCardAdmin from "./TestingEventCardAdmin";
import StandardEventCardAdmin from "./StandardEventCardAdmin";
import { getEventCardMetrics } from "./cardUtils";
import { eventCardShape } from "./eventPropTypes";

export default function EventCardAdmin(props) {
  const {
    event,
    canEdit,
    onEdit,
    onDelete,
    onManageParticipants,
    onDetail,
    onToggleVisibility,
    onCollectFees,
    onOpenPublicBooking,
    onCopyPublicBookingLink,
    onShowPublicBookingQR,
    canOpenMemberBookingDetails,
    onMemberBookingDetail,
  } = props;
  const { isBooking, isTesting } = getEventCardMetrics(event);

  if (isBooking) {
    return (
      <BookingEventCardAdmin
        event={event}
        canEdit={canEdit}
        onEdit={onEdit}
        onDelete={onDelete}
        onManageParticipants={onManageParticipants}
        onDetail={onDetail}
        onToggleVisibility={onToggleVisibility}
        onCollectFees={onCollectFees}
        onOpenPublicBooking={onOpenPublicBooking}
        onCopyPublicBookingLink={onCopyPublicBookingLink}
        onShowPublicBookingQR={onShowPublicBookingQR}
        canOpenMemberBookingDetails={canOpenMemberBookingDetails}
        onMemberBookingDetail={onMemberBookingDetail}
      />
    );
  }

  if (isTesting) {
    return (
      <TestingEventCardAdmin
        event={event}
        canEdit={canEdit}
        onEdit={onEdit}
        onDelete={onDelete}
        onManageParticipants={onManageParticipants}
        onDetail={onDetail}
        onToggleVisibility={onToggleVisibility}
        onCollectFees={onCollectFees}
      />
    );
  }

  return (
    <StandardEventCardAdmin
      event={event}
      canEdit={canEdit}
      onEdit={onEdit}
      onDelete={onDelete}
      onManageParticipants={onManageParticipants}
      onDetail={onDetail}
      onToggleVisibility={onToggleVisibility}
      onCollectFees={onCollectFees}
    />
  );
}

EventCardAdmin.propTypes = {
  event: eventCardShape,
  canEdit: PropTypes.bool,
  onEdit: PropTypes.func,
  onDelete: PropTypes.func,
  onManageParticipants: PropTypes.func,
  onDetail: PropTypes.func,
  onToggleVisibility: PropTypes.func,
  onCollectFees: PropTypes.func,
  onOpenPublicBooking: PropTypes.func,
  onCopyPublicBookingLink: PropTypes.func,
  onShowPublicBookingQR: PropTypes.func,
  canOpenMemberBookingDetails: PropTypes.bool,
  onMemberBookingDetail: PropTypes.func,
};

EventCardAdmin.defaultProps = {
  event: null,
  canEdit: false,
  onEdit: undefined,
  onDelete: undefined,
  onManageParticipants: undefined,
  onDetail: undefined,
  onToggleVisibility: undefined,
  onCollectFees: undefined,
  onOpenPublicBooking: undefined,
  onCopyPublicBookingLink: undefined,
  onShowPublicBookingQR: undefined,
  canOpenMemberBookingDetails: false,
  onMemberBookingDetail: undefined,
};
